import { Link, useLocation, useNavigate } from 'react-router-dom';

function NavLink({ href, label, isExternal = false, spacing = '', onClick, className: customClassName = '' }) {
  const location = useLocation();
  const navigate = useNavigate();
  const baseClassName = `text-primary font-normal hover:underline active:underline transition-all text-sm ${spacing}`;
  const className = customClassName ? `${baseClassName} ${customClassName}` : baseClassName;
  
  if (isExternal || href.startsWith('http') || href.startsWith('mailto') || href.endsWith('.pdf')) {
    return (
      <a
        href={href}
        target={isExternal ? "_blank" : undefined}
        rel={isExternal ? "noopener noreferrer" : undefined}
        className={className}
        onClick={onClick}
      >
        {label}
      </a>
    );
  }

  // Handle hash links (anchor links) for smooth scrolling
  if (href.startsWith('#')) {
    const handleClick = (e) => {
      e.preventDefault();
      
      // If not on homepage, navigate to homepage first, then scroll
      if (location.pathname !== '/') {
        navigate('/');
        // Wait for navigation to complete, then scroll
        setTimeout(() => {
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      } else {
        // Already on homepage, just scroll
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      
      if (onClick) onClick();
    };
    
    return (
      <a href={href} onClick={handleClick} className={className}>
        {label}
      </a>
    );
  }

  return (
    <Link to={href} className={className} onClick={onClick}>
      {label}
    </Link>
  );
}

export default NavLink;

